export default __webpack_public_path__ + "static/media/Curso-bulltopedia.12c403ce.webp";